import React, { FC } from "react";
import classNames from "classnames";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { IRichText, TextType } from "@app/models/storyblok/basic";

type Props = {
  title: IRichText<TextType>;
  text: IRichText<TextType>;
};

export const Description: FC<Props> = ({ title, text }) => (
  <div className={classNames("text-regular text-base-400", "lg:text-medium")}>
    <BlockHeader
      richText={title}
      className={classNames(
        "mb-6 text-medium text-primary-content",
        "lg:mb-4 lg:text-large",
        "xl:hidden",
      )}
    />
    <BlockBody richText={text} />
  </div>
);
